module.exports = __webpack_public_path__ + "media/images/1782_white-447f9c32beac7ee66a8a90addf37a581.jpg";